<template>
  <v-container fluid>
    <HeaderLabel class="mb-2" title="Member profile details" />
    <div class="custom-container-box">
      <v-row>
        <v-col cols="12" :md="isClient ? 6 : 12">
          <MemberProfileEditForm
            :id="id"
            :profile="profile"
            @create="createProfile"
            @update="updatedProfile"
            :is-submitting="isSubmitting"
          />
        </v-col>
        <v-col v-if="isClient" cols="12" md="6">
          <v-tabs v-model="rightTabs">
            <v-tab> Patient List </v-tab>
            <v-tab> Booking List </v-tab>
          </v-tabs>
          <v-tabs-items v-model="rightTabs" touchless>
            <v-tab-item>
              <PatientsList v-model="profile.patients" @change="onPatientsChange" />
            </v-tab-item>
            <v-tab-item>
              <BookingList :member-id="id" list-title="" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
    <!-- <div>
      <v-row>
        <v-col cols="12" :md="isClient ? 6 : 12">
          <v-tabs v-model="profileTabs">
            <v-tab v-if="isClient">Profile</v-tab>
          </v-tabs>
          <v-tabs-items v-model="profileTabs" touchless>
            <v-tab-item>
              <MemberProfileEditForm
                :id="id"
                :profile="profile"
                @create="createProfile"
                @update="updatedProfile"
                :is-submitting="isSubmitting"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col v-if="isClient" cols="12" md="6">
          <v-tabs v-model="clientTabs">
            <v-tab> Booking</v-tab>
          </v-tabs>
          <v-tabs-items v-model="clientTabs" touchless>
            <v-tab-item>
              <BookingList :member-id="id" list-title="Member Bookings" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div> -->
  </v-container>
</template>

<script>
import api from '@/api';
import { readProfile, readProfileByMaster } from '@/api/auth/membership';
import { roles, RESTFUL } from '@/data/constants';
import MemberProfileEditForm from '@/components/Identity/ProfileEditForm.vue';
import BookingList from '@/components/Booking/BookingList.vue';
import PatientsList from '@/components/MemberProfile/PatientsList.vue';
import { mapGetters } from 'vuex';
import { updateProfile } from '@/api/profile';
import ApiError from '@/api/ApiError';
import { getOid } from '@/services/utils';
import { listPaymentMethods, deletePaymentMethods } from '@/api/payment';
import { patchUser } from '@/api/auth/membership';
import { crudCreate } from '@/api/crud';
import HeaderLabel from '@/components/customFormLabel/headerLabel.vue';
export default {
  name: 'memberProfileDetails',
  components: {
    MemberProfileEditForm,
    BookingList,
    PatientsList,
    HeaderLabel,
  },
  props: {
    id: {},
  },
  data() {
    return {
      model: {},
      paymentMethodData: [],
      clientTabs: null,
      profileTabs: null,
      rightTabs: null,
      profile: {},
      isSubmitting: false,
      isUpdatingPatients: false,
      RESTFUL,
    };
  },
  computed: {
    ...mapGetters('auth', ['role', 'isClinicStaff']),
    isClient() {
      return this.profile.role === roles.member;
    },
  },
  watch: {
    id: {
      immediate: true,
      handler(v) {
        if (v) {
          this.reload();
        }
      },
    },
  },
  methods: {
    async updatedProfile(v) {
      this.isSubmitting = true;
      try {
        await updateProfile(api, this.id, v);
        if (this.profile?.user?._id) {
          await patchUser(api, this.profile?.user?._id, { enabled: v?.enabled });
        } else if (v?.enabled) {
          await crudCreate(
            api,
            RESTFUL.user.create,
            { profiles: [this.id], phone: v?.phone },
            { params: { noProfile: true } },
          );
        }
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Updated',
          type: 'success',
          color: 'success',
        });
        this.reload();
      } catch (err) {
        this.handleError(err);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onPatientsChange() {
      this.isUpdatingPatients = true;
      try {
        await updateProfile(api, this.id, { patients: this.profile.patients });
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Patients updated',
          type: 'success',
          color: 'success',
        });
      } catch (err) {
        this.handleError(err);
      } finally {
        this.isUpdatingPatients = false;
      }
    },
    // async updatedVip(v) {
    //   const { _VIP_activated, _VIP_upcoming } =
    //     (await readProfile(api, this.id, {
    //       select: [{ _VIP_activated: 1 }],
    //       populate: [{ path: '_VIP_activated' }, { path: '_VIP_upcoming' }],
    //     })) || {};
    //   this.$set(this.profile, '_VIP_activated', _VIP_activated);
    //   this.$set(this.profile, '_VIP_upcoming', _VIP_upcoming);
    //   this.$refs.vipPurchaseRecord?.reload();
    // },
    // async requireDeletePaymentMethod(item) {
    //   if (!confirm('Do you confirm to delete?')) return;
    //   try {
    //     await deletePaymentMethods(api, item.id);
    //     await this.$store.dispatch('alert/updateAlertMessage', {
    //       msg: 'Deleted',
    //       type: 'success',
    //       color: 'success',
    //     });
    //     const i = this.paymentMethodData.findIndex(el => el.id === item.id);
    //     this.paymentMethodData.splice(i, 1);
    //   } catch (err) {
    //     this.handleError(err);
    //   }
    // },
    createProfile() {},
    async reload() {
      if (this.role !== roles.master) {
        this.profile = await readProfile(api, this.id, {
          populate: [{ path: 'user' }, { path: '_VIP_activated' }, { path: '_VIP_upcoming' }],
        });
        if (this.isClinicStaff || this.isAdmin || this.isCashier) {
          this.userId = getOid(this.profile.user);
        }
      } else {
        this.profile = await readProfileByMaster(api, this.id);
      }
    },
    handleError(err) {
      const ae = ApiError.wrap(err);
      this.$store.dispatch('alert/updateAlertMessage', {
        msg: ae.message,
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
